import { render } from "./Turmoil.vue?vue&type=template&id=5e3e875a&ts=true"
import script from "./Turmoil.vue?vue&type=script&lang=ts"
export * from "./Turmoil.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__